import { Router, ActivatedRoute} from "@angular/router";
import {
  Component,
  ElementRef,
  OnInit,
  QueryList,
  ViewChildren,
} from "@angular/core";

import { LoginService } from "../login/login.service";

import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import CssFilterConverter from "css-filter-converter";
import { setting } from "../../../../setting";
import { Subscription } from "rxjs";
import { HttpErrorResponse } from "@angular/common/http";
import { ClientService } from "../../services/client.service";
import { NotificationService } from "../../shared/notifications/notification.service";

declare var Raphael: any;

@Component({
  selector: "usb-select",
  templateUrl: "./select.component.html",
  styleUrls: ["./select.component.scss"],
})
export class SelectComponent implements OnInit{
  @ViewChildren("icon", { read: ElementRef }) icons: QueryList<ElementRef>;
  public load: boolean = true;
  public modules: any;
  public urls: any;
  public activeform: any;
  public user: any;
  public id: any;
  public change_password: any;
  // TODO: confirmar con backend el nombre exacto del campo en la respuesta de getCurrent().
  public two_factor_enabled: boolean = false;
  public app: any = {
    booking: false,
    booking_name: "",
    booking_url: "#",
    booking_backoffice: false,
    booking_backoffice_name: "",
    booking_backoffice_url: "#",
    abaco: false,
    abaco_url: "#",
    chat: false,
    chat_url: "#",
    zoco: false,
    zoco_name: "",
    zoco_url: "#",
  };
  public module_names: any;
  public perfil: any;
  public nameAgency: any;
  modalRef: BsModalRef;
  public agencysUser;
  public data;
  public getClientsSettingAppAuth: any;
  public sectionHub: any;
  public routeUploadFile: any;
  public filter?: any;
    showModal = false;

  /*--------- Hover icon select app -------------*/
  bookingHover: boolean = true;
  chatHover: boolean = true;
  abacoHover: boolean = true;
  backofficeHover: boolean = true;
  zocoHover: boolean = true;

  private currentUserSubscription: Subscription;
  private listToModuleSubscription: Subscription;
  private getProfileUserSubscription: Subscription;
  private getInfoAgencySubscription: Subscription;

  private accessName: any[] = [
    'backoffice.acceso.habilitar',
    'booking.acceso.habilitar',
    'zoco.acceso.habilitar',
    'abaco.acceso.habilitar'
  ];

  constructor(
    private _loginService: LoginService,
    public _router: Router,
    public activatedRoute: ActivatedRoute,
    private modalService: BsModalService,
    private clientService: ClientService,
    private notificationService: NotificationService
  ) {
    this.load = true;
    this.module_names = setting.app_names;
  }


  ngOnInit() {
    this.load = true;
     this.clientService.clientData$.subscribe((data) => {
            		this.getClientsSettingAppAuth = data;
            		this.parseSectionHub();
            		this.applyImageFilter();
      });

        // Si ya hay datos disponibles sincrónicamente
      if (this.clientService.getClientData()) {
            this.getClientsSettingAppAuth = this.clientService.getClientData();
      }
    this.parseSectionHub();
    this.initUser(); // get the user info.
    this.applyImageFilter();
  }

  // clientData$ puede emitir null la primera vez (todavía no llegó la respuesta de
  // getClientsSettingAppAuth, p. ej. en un dominio sin cache en localStorage): sin
  // esta guarda, JSON.parse(undefined) tira "undefined is not valid JSON".
  private parseSectionHub(): void {
    const raw = this.getClientsSettingAppAuth?.clients_setting_app_auth?.section_hub;
    this.sectionHub = typeof raw === 'string' ? JSON.parse(raw) : null;
  }



  initUser() {

    this.routeUploadFile = setting.routeUploadFile;
    // initializes the user's info. La sesión vive en la cookie HttpOnly auth_token,
    // que el JS no puede leer: en vez de chequearla antes, se intenta directamente
    // y el backend responde 401 si no hay sesión válida.
    this.currentUserSubscription =  this._loginService.getCurrentCached().subscribe(
        (data: any) => {
          if (data.res == 1) {
            this.user = data.det;
            this.validIp(this.user);
            this.id = this.user.id;
            this.change_password = this.user.change_password;
            this.two_factor_enabled = !!this.user.two_factor_enabled;
            this.getProfileUser();
            this.getModules();
            this.getInfoAgency(this.user);
          } else {
            this.load = false;
            this._router.navigate(["/home", {}]); // redirects to home with toast
          }
        },
        (error) => {
          this.load = false;
          this._router.navigate(["/home", {}]); // redirects to home with toast
        }
      );
  }

  validIp(user: any): void {

    if(user.register_user_ip === null) {
      this.showModal = true;
    }
  }

    getModules() {
    this.listToModuleSubscription =  this._loginService.listToModulesUser().subscribe({
        next: (data: any) => {
          if (data.status == 200) {
            this.modules = data.data["mod"];
            this.urls = data.data["url"];
            this.arrangeDesk();
          } else {
            this.load = false;
          }
        },
       error: (error: Error) => {
          this.load = false;
        }
      });
    }

      private directAccess(permissions: any[]): void {
          // Filtrar solo los permisos de acceso que nos interesan
          const userAccessPermissions = permissions.filter(permission =>
            this.accessName.includes(permission.name)
          );

          // Verificar la cantidad de permisos de acceso
          if (userAccessPermissions.length === 1) {
            // CASO 1: Solo tiene un permiso de acceso
            this.handleSingleAccessPermission(userAccessPermissions[0]);
          } else if (userAccessPermissions.length === 0) {
            // CASO 2: No tiene ningún permiso de acceso
            this.showNoAccessAlert();
          } else if ( userAccessPermissions.length > 1) {
            this.load = false;

          }

        }

        private handleSingleAccessPermission(permission: any): void {

  // Mostrar alerta al usuario
  const platformName = this.getPlatformName(permission.name);
  // alert(`Solo tienes acceso a la plataforma: ${platformName}. Serás redirigido automáticamente.`);

  // Redirigir automáticamente
  this.redirectBasedOnPermission(permission.name);
}

private showNoAccessAlert(): void {
  console.warn('El usuario no tiene permisos de acceso a ninguna plataforma');
  alert('No tienes permisos de acceso a ninguna plataforma. Por favor, contacta al administrador.');
}

private getPlatformName(permissionName: string): string {
  const platformNames = {
    'backoffice.acceso.habilitar': 'Backoffice',
    'booking.acceso.habilitar': 'Booking',
    'zoco.acceso.habilitar': 'Zoco',
    'abaco.acceso.habilitar': 'Ábaco'
  };

  return platformNames[permissionName] || permissionName;
}

private redirectBasedOnPermission(permissionName: string): void {
  const redirectUrls = {
    'backoffice.acceso.habilitar': setting.appBookingBackoffice,
    'booking.acceso.habilitar': setting.appBookingUrl,
    'zoco.acceso.habilitar': setting.appZocoUrl,
    'abaco.acceso.habilitar': setting.appAbacoUrl
  };

  const redirectUrl = redirectUrls[permissionName];

  if (redirectUrl) {
    setTimeout(() => {

      window.location.href = redirectUrl;
    }, 0);

  }
}




  getProfileUser() {
    this._loginService.getProfileUser().subscribe({
     next: (data: any) => {
        this.perfil = data.id;
      },
     error: (error: Error) => {
        this.load = false;
      }
    });
  }

  getInfoAgency(user: any) {
    this.getInfoAgencySubscription = this._loginService.getInfoAgency(user).subscribe(
      (response: any) => {
        if(response.data.length > 0) {
          this.nameAgency = response.data[0].name;
        }
      },
      (error) => {
        this.load = false;
      }
    );
  }

  arrangeDesk() {
    for (let i = 0; i < this.modules.length; i++) {
      if (this.modules[i]["name"] === "backoffice.acceso.habilitar") {
        this.app.booking_backoffice = true;
        this.app.booking_backoffice_url = setting.appBookingBackoffice;
        this.app.booking_backoffice_name = setting.app_names.booking_backoffice;
      }

      if (this.modules[i]["name"] === "booking.acceso.habilitar") {
        this.app.booking = true;
        this.app.booking_url = setting.appBookingUrl;
        this.app.booking_name = setting.app_names.booking;
      }

      if (this.modules[i]["name"] === "zoco.acceso.habilitar") {
        this.app.zoco = true;
        this.app.zoco_url = setting.appZocoUrl;
        this.app.zoco_name = setting.app_names.zoco;
      }

      if (this.modules[i]["name"] === "abaco.acceso.habilitar") {
        this.app.abaco = true;
        this.app.abaco_url = setting.appAbacoUrl;
        this.app.abaco_name = setting.app_names.abaco;
      }
    }
    this.load = false;
  }

  onLogout() {
    let data = {
      email: this.user.email,
    };

    this._loginService.logout(data).subscribe(
      (data: any) => {
        this._loginService.clearCurrentUserCache();
        if (data.res == 1) {
          this.notificationService.success('Sesion cerrada con éxito');
          this._router.navigate(["/home", {}]);
        } else {
          this._router.navigate(["/home", {}]);
        }
      },
      (error) => {
        this.notificationService.error(JSON.parse(error.error).det);
      }
    );
  }

  // Aplica un filtro de css al elemento de imagen utilizando el color seteado por cliente.
  applyImageFilter() {
    const color =
      this.getClientsSettingAppAuth?.clients_setting_global?.color_main_3;
    if (!color) return;
    const tempFilterObj = CssFilterConverter.hexToFilter(color, {
      sheen: false,
    });

    //Extraemos el literal en String de la conversión
    const tempFilterStr = Object.keys(tempFilterObj)
      .map((key) => `${key}(${tempFilterObj[key]})`)
      .join(" ");

    // Convierte el color a un objeto de filtro de CSS y extrae los filtros de la respuesta color del resultado.
    const colorRegex = /color\((.*)\)/;
    const colorMatch = tempFilterStr.match(colorRegex);
    const colorFilter = colorMatch ? colorMatch[1] : "";

    this.filter = colorFilter;

    // Establece el atributo de estilo "filter" en el elemento de imagen con los filtros de color extraídos.
    setTimeout(() => {
      this.icons.forEach((icon) => {
        icon.nativeElement.setAttribute("style", `filter: ${this.filter}`);
      });
    }, 100);
  }


  hasAccess(appName: string): boolean {
    if (this.modules) {
      for (let i = 0; i < this.modules.length; i++) {
        const module = this.modules[i];
        if (module.name === appName) {
          return true; // Devolver `true` si el módulo existe
        }
      }

      return false; // Si no se encontró un módulo con el nombre especificado, retornar `false`
    }

    return false; // Si `this.modules` es undefined, retornar `false`
  }

  navigateToApp(url: string) {
    location.href= url;
  }

    confirmAction(accept: boolean) {

      if(accept) {
        this.closeModal();
        const data = {
          user_id: this.user.id,
          register_ip: 'register'
        }
        this._loginService.registerIP(data).subscribe({
          next: (res: any) => {
            if(res.det === 'Record updated') {
              this.notificationService.success('IP registrada con éxito');
            } else {
              this.notificationService.warning('Hubo un error al registrar su IP, intentelo más tarde. Si cree que se trata de un error comuniquesé con soporte.');
              this.onLogout();
            }
          },
          error: (error: HttpErrorResponse) => {
            console.error(error)
            this.notificationService.error('Error al registrar su IP, intentelo más tarde. Si cree que se trata de un error comuniquesé con soporte.');
          }
        });
      }  else {
        this.onLogout();
      }
  }

    closeModal() {
    this.showModal = false;
  }

}
